import React from "react";

const About = () => {
  return (
    <>
      <div className="container mt-5">
        <h2 className="text-white font-weight-bold">About</h2>
        <p className="text-white">
          LEARN WITH US
          <br /> <br />
        </p>
        <h4 className="text-white">
          Trick Piece offers you free online courses. We bring you a wide
          variety of topics, which can help you increase your knowledge to a
          great extent. If you are looking for online courses to grow your
          skills, we are here.
        </h4>
      </div>
    </>
  );
};

export default About;
